module.exports = __webpack_public_path__ + "img/shop_sign.c8fc6ac2.png";